/**
 * The sidebar item a page belongs under. Everything waiting on the person
 * (questions, approvals, an agent's initiative) is part of Home.
 */
const NAV_ITEM_FOR_PAGE = {
  inbox: 'home',
  initiatives: 'home',
  agents: 'team',
  'branch-review': 'build',
  'operations-map': 'build',
  sandbox: 'views',
};

export const navItemForPage = (page, pathname = '') => {
  if (page === 'agents' && /^\/app\/agents\/[^/]+\/initiatives\//.test(pathname)) return 'home';
  return NAV_ITEM_FOR_PAGE[page] || page || null;
};

/**
 * Admin configuration pages, in the order the More menu lists them.
 * Everyone's sidebar shows Home and published apps. Admins reach these through
 * More and can pin any of them onto that list. Access to each page is still
 * decided by the route manifest.
 */
export const CONFIG_PAGES = [
  'view-editor',
  'ontology-builder',
  'ontology-data',
  'integrations',
  'team',
  'org-chart',
  'initiatives',
  'automations',
  'build',
  'program-editor',
  'ontology-action-runs',
  'simulations',
];
